import { Button, Icon } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const StyledButton = Button.withConfig<{ noBackground?: boolean; inverted?: boolean }>(
  p => ({
    background: p.noBackground
      ? 'transparent'
      : p.inverted
      ? primitive.$bbqBrown
      : primitive.$mayoEggWhite,
    borderRadius: 'full',
    height: '$9',
    width: '$9',
  })
);

export const StyledIcon = Icon.withConfig<{ inverted?: boolean }>(p => ({
  color: p.inverted ? getDesignToken('text-button-primary') : primitive.$bbqBrown,
  ...p,
}));
